module.exports = __webpack_public_path__ + "img/nuvola_1.a5731f20.png";